import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, ShieldCheck } from "lucide-react";
import { useCart } from "@/context/CartContext";
import Logo from "@/components/Logo";

const links = [
  { to: "/loja", label: "Catálogo" },
  { to: "/loja?categoria=celulares", label: "Celulares" },
  { to: "/loja?categoria=acessorios", label: "Acessórios" },
  { to: "/loja?categoria=telas", label: "Telas" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 border-b ${
        scrolled
          ? "bg-black/70 backdrop-blur-2xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-10 h-16 flex items-center justify-between gap-6">
        <Link to="/" className="shrink-0" data-testid="nav-logo-link">
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className="text-sm text-mute hover:text-white transition-colors duration-300 tracking-wide"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/admin"
            aria-label="Painel do administrador"
            className="hidden sm:inline-flex h-10 w-10 items-center justify-center rounded-md text-mute hover:text-cyan hover:bg-white/5 transition-all duration-300"
            data-testid="nav-admin-link"
          >
            <ShieldCheck size={19} strokeWidth={1.6} />
          </Link>
          <button
            onClick={() => setOpen(true)}
            aria-label="Abrir carrinho"
            className="relative inline-flex h-10 items-center gap-2 rounded-md border border-white/15 bg-surface/80 px-4 text-sm hover:border-cyan/60 hover:text-cyan transition-all duration-300 hover:-translate-y-px"
            data-testid="cart-button"
          >
            <ShoppingCart size={17} strokeWidth={1.7} />
            <span className="hidden sm:inline">Carrinho</span>
            {count > 0 && (
              <span
                className="absolute -top-2 -right-2 h-5 min-w-5 px-1 rounded-full bg-cyan text-ink text-[11px] font-bold flex items-center justify-center"
                data-testid="cart-count-badge"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>

      <div className="md:hidden flex gap-5 overflow-x-auto px-5 pb-2.5 pt-0.5">
        {links.map((l) => (
          <Link
            key={l.label}
            to={l.to}
            className="text-xs uppercase tracking-[0.18em] text-mute hover:text-cyan transition-colors whitespace-nowrap"
          >
            {l.label}
          </Link>
        ))}
      </div>
    </header>
  );
}
